"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LoadingGraphic = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var loading_skeleton_module_scss_1 = __importDefault(require("../loading-skeleton.module.scss"));
var LoadingGraphic_module_scss_1 = __importDefault(require("./LoadingGraphic.module.scss"));
var graphicSizesRem = new Map([
    ["small", 1.25],
    ["medium", 3],
    ["large", 4.5],
    ["xlarge", 6],
    ["xxlarge", 7.5],
    ["scene", 18.75],
]);
var LoadingGraphic = function (_a) {
    var isAnimated = _a.isAnimated, isReversed = _a.isReversed, size = _a.size, classNameOverride = _a.classNameOverride, props = __rest(_a, ["isAnimated", "isReversed", "size", "classNameOverride"]);
    return (react_1["default"].createElement("div", __assign({ className: (0, classnames_1["default"])(loading_skeleton_module_scss_1["default"].base, LoadingGraphic_module_scss_1["default"].graphic, classNameOverride, isAnimated && loading_skeleton_module_scss_1["default"].animated, isReversed && LoadingGraphic_module_scss_1["default"].reversed), style: {
            width: "".concat(graphicSizesRem.get(size), "rem"),
            height: "".concat(graphicSizesRem.get(size), "rem")
        } }, props)));
};
exports.LoadingGraphic = LoadingGraphic;
exports.LoadingGraphic.displayName = "LoadingGraphic";
//# sourceMappingURL=LoadingGraphic.js.map